import { DownloadOutlined } from '@ant-design/icons'
import { Button, Table, TableColumnsType } from 'antd'
import React, { JSX, CSSProperties } from 'react'
import { fileSorter, formatBytes } from './DownloadUtils'
import { DownloadSource, RDWDocumentStatus } from '../../utils/enums'

export interface SecondaryTableType {
  key: React.Key
  Filename: string
  Path: string
  Size: number
  SubmissionId: string
  DocumentId: string
}

export interface DownloadTableSecondaryProps {
  order: number
  uwi: string
  data: SecondaryTableType[]
  downloadHandler: (order: number, uwi?: string, file?: string) => void
  isLookPrimary?: boolean
}

const DownloadSecondaryTable = (props: DownloadTableSecondaryProps): JSX.Element => {
  const isLookPrimary = props.isLookPrimary === true

  const columns: TableColumnsType<SecondaryTableType> = [
    {
      title: '',
      dataIndex: ['Id'],
      render: (_value, _record, index) => {
        return `${index + 1}.`
      },
      align: 'right',
      width: '3ch',
    },
    {
      title: 'File Name',
      dataIndex: ['Filename'],
    },
    {
      title: 'File Size',
      dataIndex: ['Size'],
      render: (value) => formatBytes(value ?? 0),
    },
    {
      title: '',
      dataIndex: ['Path'],
      render: (value, record: any) => {
        if (record.Source === DownloadSource.ONESTOP && !record.DocumentId) {
          return <></>
        }

        return (
          <div style={{ margin: '0 8ch 0 0' }}>
            <Button
              type="default"
              shape="circle"
              icon={<DownloadOutlined />}
              onClick={() => props.downloadHandler(props.order, props.uwi, value)}
            />
          </div>
        )
      },
      align: 'right',
    },
  ]

  if (!isLookPrimary) {
    columns.splice(3, 0, {
      title: 'Submission ID',
      dataIndex: ['SubmissionId'],
    })

    columns.splice(4, 0, {
      title: 'Document ID',
      dataIndex: ['DocumentId'],
      render: (value, record: any) => {
        if (record.Source === DownloadSource.ONESTOP) {
          if (value && value !== '') {
            return <span>{RDWDocumentStatus.Available}</span>
          }
          return <span>{RDWDocumentStatus.Missing}</span>
        }
      },
    })
  }

  const styles: CSSProperties = isLookPrimary
    ? {}
    : { margin: '0 0 2rem 5ch', borderBottom: '1px solid #CCC' }

  return (
    <div style={styles}>
      <Table
        bordered={isLookPrimary}
        columns={columns}
        rowKey={(record) => record.Filename}
        dataSource={props.data.sort(fileSorter)}
        pagination={false}
      />
    </div>
  )
}

export default DownloadSecondaryTable
